// Verve — scripts propios de marca
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initGaleriaProducto();
  initVariantesProducto();
  initFaq();
  initTestimoniosCarrusel();
});

function initReveal() {
  var elementos = document.querySelectorAll('.vv-reveal, .vv-reveal-stagger');
  if (!elementos.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach(function (el) { el.classList.add('vv-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vv-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  elementos.forEach(function (el) { observer.observe(el); });
}

function initContadores() {
  var contadores = document.querySelectorAll('.vv-count[data-target]');
  if (!contadores.length) return;

  var animar = function (el) {
    var destino = parseFloat(el.getAttribute('data-target')) || 0;
    var duracion = 1400;
    var inicio = null;
    var sufijo = el.getAttribute('data-suffix') || '';
    function paso(ts) {
      if (!inicio) inicio = ts;
      var progreso = Math.min((ts - inicio) / duracion, 1);
      var facilitado = 1 - Math.pow(1 - progreso, 3);
      el.textContent = Math.floor(facilitado * destino).toLocaleString('en-US') + sufijo;
      if (progreso < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  };

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    contadores.forEach(function (el) {
      el.textContent = (el.getAttribute('data-target') || '0') + (el.getAttribute('data-suffix') || '');
    });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { animar(entry.target); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.5 });
  contadores.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-vv-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-vv-imagen-principal]');
  var miniaturas = galeria.querySelectorAll('[data-vv-miniatura]');
  if (!principal || !miniaturas.length) return;
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      if (!full) return;
      principal.src = full;
      principal.alt = mini.getAttribute('data-alt') || '';
      miniaturas.forEach(function (m) { m.classList.remove('vv-miniatura-activa'); });
      mini.classList.add('vv-miniatura-activa');
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-vv-form-producto]');
  if (!form) return;
  var datosEl = document.querySelector('[data-vv-variantes-json]');
  if (!datosEl) return;
  var variantes;
  try { variantes = JSON.parse(datosEl.textContent); } catch (e) { return; }

  var selects = form.querySelectorAll('[data-vv-opcion]');
  var inputId = form.querySelector('[data-vv-variant-id]');
  var precioEl = document.querySelector('[data-vv-precio]');
  var precioComparado = document.querySelector('[data-vv-precio-comparado]');
  var botonSubmit = form.querySelector('[data-vv-boton-comprar]');
  if (!selects.length || !inputId) return;

  function actuales() { var a = []; selects.forEach(function (s) { a.push(s.value); }); return a; }

  function actualizar() {
    var a = actuales();
    var encontrada = variantes.find(function (v) { return v.options.every(function (opt, i) { return opt === a[i]; }); });
    if (!encontrada) return;
    inputId.value = encontrada.id;
    var formatearPrecio = function (n) { return '$' + Math.round(n).toLocaleString('es-MX'); };
    if (precioEl && encontrada.price) precioEl.textContent = formatearPrecio(encontrada.price);
    if (precioComparado) {
      if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
        precioComparado.textContent = formatearPrecio(encontrada.compare_at_price);
        precioComparado.style.display = '';
      } else { precioComparado.style.display = 'none'; }
    }
    if (botonSubmit) {
      if (encontrada.available) {
        botonSubmit.disabled = false;
        botonSubmit.textContent = botonSubmit.getAttribute('data-texto-disponible') || botonSubmit.textContent;
      } else {
        botonSubmit.disabled = true;
        botonSubmit.textContent = botonSubmit.getAttribute('data-texto-agotado') || 'Sold out';
      }
    }
  }
  selects.forEach(function (sel) { sel.addEventListener('change', actualizar); });
  actualizar();
}

function initFaq() {
  var items = document.querySelectorAll('[data-vv-faq-pregunta]');
  items.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-vv-faq-item]');
      if (!item) return;
      var abierto = item.classList.contains('vv-faq-abierta');
      document.querySelectorAll('[data-vv-faq-item]').forEach(function (i) { if (i !== item) i.classList.remove('vv-faq-abierta'); });
      item.classList.toggle('vv-faq-abierta', !abierto);
    });
  });
}

function initTestimoniosCarrusel() {
  var track = document.querySelector('[data-vv-testimonios-track]');
  if (!track) return;
  var prev = document.querySelector('[data-vv-testimonios-prev]');
  var next = document.querySelector('[data-vv-testimonios-next]');
  var tarjetas = track.children.length;
  if (!tarjetas) return;
  var indice = 0;
  function mover(dir) {
    var ancho = track.children[0].getBoundingClientRect().width + 24;
    indice = Math.max(0, Math.min(indice + dir, tarjetas - 1));
    track.scrollTo({ left: indice * ancho, behavior: 'smooth' });
  }
  if (prev) prev.addEventListener('click', function () { mover(-1); });
  if (next) next.addEventListener('click', function () { mover(1); });
}
